<div class="main-container">
  <div class="d-flex" [ngClass]="flexColumn? 'flex-column': ''">
    <div *ngFor="let item of items; let i = index" class="me-1 d-flex item-container" [ngClass]="flexColumn? 'mb-1': ''">
      <input
        type="checkbox"
        [checked]="isSelected(item.key)"
        [disabled]="isCheckboxDisabled(item.key)"
        (change)="toggleSelection(item.key)"
      />
      <label for="" class="item-label"><ion-icon [name]="getIconName(item)"></ion-icon> {{ item.name }}</label>
    </div>
  </div>
</div>
